import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=8888570c&scoped=true"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=8888570c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8888570c",
  null
  
)

export default component.exports